export default async (context, { store_url, redirect }) => {
    if(context.temporaryData) {
        await context.$store.dispatch(store_url, {
            video: context.temporaryData
        })
        await context.$router.push(redirect)
    }
}